import env from '../config.json';

import { METHODS } from '../const/config';

const { PKG_BASE_URL } = env;
// const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NGUzNTRhOGIzMGVkMzIxODc5YjNjNjEiLCJpYXQiOjE3MTc5OTU0NDYsImV4cCI6MTcxNzk5OTA0Nn0.qeKkYoDNLxnxLclCOQ8l94PAaHId4u4FLxx1myX570g'
 const staticToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcmVhdGVkX2F0IjoxNzM5OTYzODU0ODA0LCJ1cGRhdGVkX2F0IjoxNzQ4NTgzMDMwMjc5LCJpZCI6IjY3YjViZGNlZTMwYzY4M2VjMGVjY2U0MCIsImZpcnN0X25hbWUiOiJBa2hpbGVzaCIsImxhc3RfbmFtZSI6IiIsImNvdW50cnlDb2RlIjo5MSwicGhvbmVfbnVtYmVyIjo5OTcyMTUxNTE4LCJkZXZpY2VfbnVtYmVyIjoiV0VCLURFVklDRS0xMjM0NTYiLCJlbWFpbF9pZCI6IiIsImF2YXRhcl91cmwiOiIiLCJnZW5kZXIiOiIiLCJkb2IiOm51bGwsInByZWZlcnJlZExhbmd1YWdlIjoiZW4tVVMiLCJwYXNzd29yZCI6IiQyYiQxMCRZc1lzcHJGV0pzdmJVbEtvOTk3dWdlV1hEWEtoMlpRZ3VwNjRhQnBibHJrT0Z5TTQ3a3pDTyIsIm90cCI6IjA2NTEiLCJvdHBNb2RlIjoiV0hBVFNBUFAiLCJvdHBfZXhwaXJhdGlvbiI6MTc0NDY5NTQ5ODY1MSwiZmNtX3Rva2VuIjoiY2JIZm05VllRX0dYOXgxVmZhZ0VaMTpBUEE5MWJHZ1ZBcW45ejlUdDlQaHJoTkJDVVBiMFdHS2hiUzNqOXNQTzdrck5TVGpvaGpBdEZFYUhhSFlYbzliM2RxR1M1bk9fWEtLcHhqaTBuYlJLM1NmcmRneUVQemxPS1Q5S3ZzSW14dldxeDhMdERQSzY5QSIsImlzX25ld191c2VyIjpmYWxzZSwiaXNfdXNlciI6dHJ1ZSwiaXNfYWN0aXZlIjp0cnVlLCJpc190Y19hY2NlcHRlZCI6dHJ1ZSwiZGV2aWNlRGV0YWlscyI6eyJicm93c2VyIjoiTW96aWxsYS81LjAgKFdpbmRvd3MgTlQgMTAuMDsgV2luNjQ7IHg2NCkgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEzMi4wLjAuMCBTYWZhcmkvNTM3LjM2IiwicGxhdGZvcm0iOiJXaW4zMiJ9LCJsYXN0QWNjZXNzZWQiOiIyMDI1LTAyLTE5VDExOjE3OjM0LjM5MVoiLCJjdXJyZW50X2xvY2F0aW9uIjpudWxsLCJyYXRpbmciOjUsImVtZXJnZW5jeV9jb250YWN0IjoiIiwiZGVidWdfbGV2ZWwiOiIiLCJpYXQiOjE3NDg1ODM5OTksImV4cCI6MTc4MDExOTk5OX0.9lIGpLaE2I-VUHRES0IPZexw6JQmqt9pS2KRBupcCRs'
function joinUrl(url) {
    return PKG_BASE_URL + url;
}

class TourPackageHttp{
    constructor() {
        // assign base url to local variable
        this.baseurl = PKG_BASE_URL;
    }

     // Helper function to get token from localStorage
     static getToken() {
        // Assuming token is stored under the key 'token'
       const tokenFromStorage = localStorage.getItem('token');

        return tokenFromStorage || staticToken;
    }

   
    static async request(url, method, data) {
        // Get headers before API call
        // const headers =a await getHeaders();
        console.log("data in request ",data)

         // Fetch the token from localStorage
         const token = this.getToken();

         console.log("token in http", token);
         
        // Create options for the API call
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json', // Set Content-Type header to application/json
                'Authorization': `Bearer ${token}`
            },
            // headers,
        };

        // If data add it in to body
        // Stringfy the body
        if (data != null) {
            options.body = JSON.stringify(data);
            console.log("options.body",options.body)
            // console.log("data",data)
        }

        // Return fetch response
        // return fetch(url, options).then(res => {
        //     // console.log("res.json()",res.json())
        //     res.json();
        // });
        try {
            // return fetch(url, options).then(res => res.json());
            console.log("url in http ",url,options)
            const response = await fetch(url, options);
            console.log(
                "response in https",response
            )
            // await  console.log("response in http options",response.json());
            const data = await response.json();
            console.log("response in http data", data);
            return data; // This will return the array
        } catch (err) {
            console.log("error in http", err);
            throw err; // Re-throw the error if needed
        }
      
       

    }



    // Post method
    static async post(url, data = {}) {
        console.log('in Http post ',joinUrl(url), METHODS.POST, data)
        return this.request(joinUrl(url), METHODS.POST, data);
    }
      // Get method
      static async get(url) {
        console.log('in Http get',joinUrl(url), METHODS.GET, )
        return this.request(joinUrl(url), METHODS.GET);
        // return fetch(url, METHODS.GET).then(res => res.json());
    }
     // Update method
     static async update(url, data = {}) {
        console.log("data in http ",data)
        return this.request(joinUrl(url), METHODS.PUT, data);
    }
    // Delete method
    static async delete(url) {
        console.log("url",url)
        return this.request(joinUrl(url), METHODS.DELETE);
    }
}
export default TourPackageHttp;